import { render, staticRenderFns } from "./power-edit.vue?vue&type=template&id=622d7854&scoped=true&"
import script from "./power-edit.vue?vue&type=script&lang=js&"
export * from "./power-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d7854",
  null
  
)

export default component.exports